/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ReceiptInputs */

const en_receipt = /** @type {(inputs: ReceiptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receipt`)
};

const es_receipt = /** @type {(inputs: ReceiptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibo`)
};

const fr_receipt = /** @type {(inputs: ReceiptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reçu`)
};

const de_receipt = /** @type {(inputs: ReceiptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quittung`)
};

const ja_receipt = /** @type {(inputs: ReceiptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`領収書`)
};

const zh_receipt = /** @type {(inputs: ReceiptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收据`)
};

const ar_receipt = /** @type {(inputs: ReceiptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإيصال`)
};

const id_receipt = /** @type {(inputs: ReceiptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanda Terima`)
};

const it_receipt = /** @type {(inputs: ReceiptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevuta`)
};

const ru_receipt = /** @type {(inputs: ReceiptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чек`)
};

const pt_receipt = /** @type {(inputs: ReceiptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibo`)
};

const ko_receipt = /** @type {(inputs: ReceiptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`영수증`)
};

/**
* | output |
* | --- |
* | "Receipt" |
*
* @param {ReceiptInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const receipt = /** @type {((inputs?: ReceiptInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ReceiptInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_receipt(inputs)
	if (locale === "es") return es_receipt(inputs)
	if (locale === "fr") return fr_receipt(inputs)
	if (locale === "de") return de_receipt(inputs)
	if (locale === "ja") return ja_receipt(inputs)
	if (locale === "zh") return zh_receipt(inputs)
	if (locale === "ar") return ar_receipt(inputs)
	if (locale === "id") return id_receipt(inputs)
	if (locale === "it") return it_receipt(inputs)
	if (locale === "ru") return ru_receipt(inputs)
	if (locale === "pt") return pt_receipt(inputs)
	return ko_receipt(inputs)
});